// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"488":"4adeecfc2ded2ba69360","532":"8bbf4a81c065a9b9699d","569":"a4cd5cb33709778c9049","592":"8a99d4168763560167e8","736":"ebfe9ef7c5c92e99bab8"}[chunkId] + ".js";
};